import { render, staticRenderFns } from "./ClinicMain.vue?vue&type=template&id=4c257e5f"
import script from "./ClinicMain.vue?vue&type=script&lang=js"
export * from "./ClinicMain.vue?vue&type=script&lang=js"
import style0 from "./ClinicMain.vue?vue&type=style&index=0&id=4c257e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports